<ng-template #feed_in_controllability_contract>
  <label class="ui-g-5 required">
    {{ 'regep.feed-in-controllability-contract' | translate }}
  </label>
  <app-file-upload
    class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
    [fileData]="technicalData.feed_in_controllability_contract"
    [isDetailsView]="isDetailsView && technicalData.feed_in_controllability_contract.document_id"
    [type]="documentTypes.FeedInControllabilityContract"
    [isClearButtonDisabled]="isSectionDisabled"
    [isRequired]="!isModeratorRole()"
    inputName="feedInControllabilityContract"
    (clearFileEvent)="clearFile($event)"></app-file-upload>
</ng-template>

<ng-template #downloadCenter>
  <span [innerHTML]="'regep.check-download-center-html' | translate"></span>
</ng-template>

<div class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div class="ui-g-12">
        <app-section-header
          [title]="'grid-comp.feed-in-management' | translate"
          [tooltip]="'tooltips.technical-data.regep.feed-in-management' | translate"></app-section-header>
      </div>
      <div class="section-buttons">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div class="section-wrapper margin-align" [ngClass]="getSectionLocked() !== true || !applicationId ? '' : 'disable-section'">
    <div class="top-bottom-margin">
      <div class="section-field mb-1" *ngIf="showControl">
        <p-radioButton
          inputId="feed_in_management_control_and_demand"
          name="feed_in_management"
          [value]="feedInManagementValues.controlAndDemand"
          [(ngModel)]="technicalData.feed_in_management"
          (ngModelChange)="feedInManagementChange($event)"
          required
          [disabled]="isSectionDisabled"></p-radioButton>
        <label for="feed_in_management_control_and_demand" class="ui-radiobutton-label">
          {{ 'grid-comp.control-and-demand' | translate }}
        </label>
      </div>

      <!-- CONTROL AND DEMAND -->
      <div
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 section-column section-toggle grid"
        *ngIf="technicalData.feed_in_management === 'controlAndDemand' && !hideControlAndOnDemandSupplyOfFeedInEnergy">
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'regep.preferred-provisioning-date' | translate }}
          </label>
          <div *ngIf="'app.calendar-settings' | translate as locale" class="ui-xs-12">
            <p-calendar
              tabIndex="0"
              appCalendarEscapeClose
              name="preferred_provisioning_date"
              [locale]="locale"
              [dateFormat]="dateFormat.dateFormat"
              [placeholder]="dateFormat.placeholder"
              [monthNavigator]="true"
              [yearNavigator]="true"
              [minDate]="minDate"
              class="doc-submit-datepicker"
              dateFormat="string"
              id="preferred_provisioning_date"
              inputId="basic"
              yearRange="2023:2080"
              [required]="true"
              [disabled]="isSectionDisabled"
              [(ngModel)]="technicalData.preferred_provisioning_date"></p-calendar>
          </div>
        </div>
        <div class="section-field">
          <label class="ui-g-5" [ngClass]="{ required: isDetailsView }">
            {{ 'regep.confirmed-date-for-provisioning' | translate }}
          </label>
          <div *ngIf="'app.calendar-settings' | translate as locale" class="ui-xs-12">
            <p-calendar
              tabIndex="0"
              appCalendarEscapeClose
              name="confirmed_provisioning_date"
              [locale]="locale"
              [dateFormat]="dateFormat.dateFormat"
              [placeholder]="dateFormat.placeholder"
              [monthNavigator]="true"
              [yearNavigator]="true"
              [minDate]="minDate"
              class="doc-submit-datepicker"
              dateFormat="string"
              id="confirmed_provisioning_date"
              inputId="basic"
              yearRange="2023:2080"
              [required]="isDetailsView"
              [disabled]="!isDetailsView || !canModeratorEdit"
              [(ngModel)]="technicalData.confirmed_provisioning_date"></p-calendar>
          </div>
        </div>

        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'regep.provisioning-will-happen-via' | translate }}
          </label>
          <div class="mr-2">
            <p-radioButton
              inputId="provisioning_type_pick_up_at"
              name="provisioning_type"
              [value]="provisioningType.PickUpAt"
              [(ngModel)]="technicalData.provisioning_type"
              required
              [disabled]="isSectionDisabled"></p-radioButton>
            <label for="provisioning_type_pick_up_at" class="ui-radiobutton-label">
              {{ 'regep.pickup-at' | translate }}
            </label>
          </div>
          <div class="mr-2">
            <p-radioButton
              inputId="provisioning_type_shipping"
              name="provisioning_type"
              [value]="provisioningType.Shipping"
              [(ngModel)]="technicalData.provisioning_type"
              (ngModelChange)="provisioningTypeUpdated($event)"
              required
              [disabled]="isSectionDisabled"></p-radioButton>
            <label for="provisioning_type_shipping" class="ui-radiobutton-label">
              {{ 'regep.shipping' | translate }}
            </label>
          </div>
        </div>

        <div class="section-field" *ngIf="technicalData.provisioning_type === provisioningType.Shipping">
          <p class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 bold">{{ 'regep.shipping-details' | translate }}</p>
        </div>

        <div class="section-field mb-1" *ngIf="technicalData.provisioning_type === provisioningType.Shipping && !isDetailsView">
          <div class="ui-g-5"></div>
          <p-checkbox
            appEnterClick
            inputId="copy_connection_address"
            class="mr-2"
            [binary]="true"
            (onChange)="toggleCopyConnectionAddress($event)"></p-checkbox>
          <label class="" for="copy_connection_address">{{ 'regep.copy-from-connection-address' | translate }}</label>
        </div>

        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mb-1"
          *ngIf="technicalData.provisioning_type === provisioningType.Shipping">
          <!-- TITLE -->
          <div class="section-field">
            <label class="ui-g-5 required" for="sk_title">
              {{ 'personal-data.form-details.fields.title' | translate }}
            </label>
            <p-dropdown
              id="sk_title"
              name="sk_title"
              [options]="allTitles"
              [(ngModel)]="technicalData.shipping_address.sk_title"
              [required]="true"
              placeholder="Please select"
              [disabled]="isSectionDisabled"></p-dropdown>
          </div>

          <!-- COMPANY -->
          <div class="section-field mb-1">
            <label class="ui-g-5" for="company_name">
              {{ 'personal-data.form-details.fields.company' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="technicalData.shipping_address.company_name"
              name="company_name"
              [disabled]="isSectionDisabled" />
          </div>

          <!-- FIRST NAME -->
          <div class="section-field mb-1">
            <label class="ui-g-5 required" for="first_name">
              {{ 'personal-data.form-details.fields.first-name' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="technicalData.shipping_address.first_name"
              name="first_name"
              required
              [disabled]="isSectionDisabled" />
          </div>

          <!-- LAST NAME -->
          <div class="section-field mb-1">
            <label class="ui-g-5 required" for="last_name">
              {{ 'personal-data.form-details.fields.last-name' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="technicalData.shipping_address.last_name"
              name="last_name"
              required
              [disabled]="isSectionDisabled" />
          </div>

          <!-- STREET -->
          <div class="section-field mb-1">
            <label class="ui-g-5 required" for="street">
              {{ 'personal-data.form-details.fields.street' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="technicalData.shipping_address.street"
              name="street"
              required
              [disabled]="isSectionDisabled" />
          </div>

          <!-- STREET NUMBER -->
          <div class="section-field mb-1">
            <label class="ui-g-5 required" for="street_number">
              {{ 'personal-data.form-details.fields.street-number' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="technicalData.shipping_address.street_number"
              name="street_number"
              required
              [disabled]="isSectionDisabled" />
          </div>

          <!-- ADDRESS SUFFIX -->
          <div class="section-field mb-1">
            <label class="ui-g-5" for="address_suffix">
              {{ 'personal-data.form-details.fields.address-suffix' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="technicalData.shipping_address.address_suffix"
              name="address_suffix"
              [disabled]="isSectionDisabled" />
          </div>

          <!-- COUNTRY -->
          <div class="section-field mb-1">
            <label class="ui-g-5 required" for="country">
              {{ 'personal-data.form-details.fields.land' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="technicalData.shipping_address.country"
              name="country"
              required
              [disabled]="isSectionDisabled" />
          </div>

          <!-- CITY -->
          <div class="section-field">
            <label class="ui-g-5 required" for="city">
              {{ 'personal-data.form-details.fields.city' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="technicalData.shipping_address.city"
              name="city"
              required
              [disabled]="isSectionDisabled" />
          </div>

          <!-- POST CODE -->
          <div class="section-field mb-1">
            <label class="ui-g-5 required" for="post_code">
              {{ 'personal-data.form-details.fields.post-code' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="technicalData.shipping_address.post_code"
              name="post_code"
              required
              [disabled]="isSectionDisabled" />
          </div>
        </div>
        <div class="ui-g-12 mb-3 pbt-8">
          <ng-template [ngTemplateOutlet]="feed_in_controllability_contract"></ng-template>
        </div>

        <div class="ui-g-12">
          <ng-template [ngTemplateOutlet]="downloadCenter"></ng-template>
        </div>

        <div class="ui-g-12 mb-3 section-field" *ngIf="canModeratorEdit || technicalData.list_of_data_points.document_id">
          <label for="list_of_data_points" class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 required">
            {{ 'regep.list-of-data-points' | translate }}
          </label>
          <app-file-upload
            class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
            id="list_of_data_points"
            [fileData]="technicalData.list_of_data_points"
            [isDetailsView]="isDetailsView && technicalData.list_of_data_points.document_id"
            [type]="documentTypes.ListOfDataPoints"
            [isClearButtonDisabled]="!canModeratorEdit"
            [isRequired]="true"
            inputName="list_of_data_points"
            (clearFileEvent)="clearFile($event)"></app-file-upload>
        </div>
      </div>

      <div class="section-field mb-1" *ngIf="showControl">
        <p-radioButton
          inputId="feed_in_management_control_according"
          name="feed_in_management"
          [value]="feedInManagementValues.controlEEG"
          [(ngModel)]="technicalData.feed_in_management"
          (ngModelChange)="feedInManagementChange($event)"
          required
          [disabled]="isSectionDisabled"></p-radioButton>
        <label for="feed_in_management_control_according" class="ui-radiobutton-label">
          {{ 'grid-comp.control-according' | translate }}
        </label>
      </div>

      <!-- CONTROL EEG -->
      <div class="ui-g-12 section-column section-toggle" *ngIf="technicalData.feed_in_management === 'controlEEG' && show9EegDetails">
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'regep.ripple-control-receiver-preferred-pickup-date' | translate }}
          </label>
          <div *ngIf="'app.calendar-settings' | translate as locale" class="upload-padding">
            <p-calendar
              tabIndex="0"
              appCalendarEscapeClose
              name="preferred_pickup_date"
              [locale]="locale"
              [dateFormat]="dateFormat.dateFormat"
              [placeholder]="dateFormat.placeholder"
              [monthNavigator]="true"
              [yearNavigator]="true"
              [minDate]="minDate"
              class="doc-submit-datepicker"
              dateFormat="string"
              id="ripple_control_receiver_preferred_pickup_date"
              inputId="basic"
              yearRange="2023:2080"
              [required]="true"
              [disabled]="isSectionDisabled"
              [(ngModel)]="technicalData.ripple_control_receiver_preferred_pickup_date"></p-calendar>
          </div>
        </div>

        <div class="section-field">
          <label [ngClass]="{ required: canModeratorEdit }" class="ui-g-5">
            {{ 'regep.ripple-control-receiver-confirmed-pickup-date' | translate }}
          </label>
          <div *ngIf="'app.calendar-settings' | translate as locale" class="upload-padding">
            <p-calendar
              tabIndex="0"
              appCalendarEscapeClose
              name="confirmed_pickup_date"
              [locale]="locale"
              [dateFormat]="dateFormat.dateFormat"
              [placeholder]="dateFormat.placeholder"
              [monthNavigator]="true"
              [yearNavigator]="true"
              [minDate]="minDate"
              class="doc-submit-datepicker"
              dateFormat="string"
              id="ripple_control_receiver_confirmed_pickup_date"
              inputId="basic"
              yearRange="2023:2080"
              [required]="canModeratorEdit"
              [disabled]="!canModeratorEdit"
              [(ngModel)]="technicalData.ripple_control_receiver_confirmed_pickup_date"></p-calendar>
          </div>
        </div>

        <div class="ui-g-12 mb-3 pbt-8">
          <ng-template [ngTemplateOutlet]="feed_in_controllability_contract"></ng-template>
        </div>

        <div class="ui-g-12">
          <ng-template [ngTemplateOutlet]="downloadCenter"></ng-template>
        </div>
      </div>
      <div class="section-field" [ngClass]="isSectionDisabled || isNoManagementDisabled ? 'disabled-radio' : ''">
        <p-radioButton
          inputId="feed_in_management_no_feed_in"
          name="feed_in_management"
          [value]="feedInManagementValues.noManagement"
          [(ngModel)]="technicalData.feed_in_management"
          (ngModelChange)="feedInManagementChange($event)"
          required
          [disabled]="isSectionDisabled"></p-radioButton>
        <label
          for="feed_in_management_no_feed_in"
          class="ml-2"
          [pTooltip]="noManagementTooltip"
          tooltipStyleClass="netz-info-tooltip"
          tooltipPosition="top">
          {{ 'grid-comp.no-feed-in' | translate }}
        </label>
      </div>
      <div class="section-field" [ngClass]="isSectionDisabled || isLimit60PercDisabled ? 'disabled-radio' : ''">
        <p-radioButton
          required
          name="feed_in_management"
          [value]="feedInManagementValues.limit60Perc"
          [(ngModel)]="technicalData.feed_in_management"></p-radioButton>
        <label class="ml-2" [pTooltip]="limit60PercTooltip" tooltipStyleClass="netz-info-tooltip" tooltipPosition="top">
          {{ 'grid-comp.limit-60-perc' | translate }}
        </label>
      </div>
      <div class="section-field" [ngClass]="isSectionDisabled || isLimit60PercPowerAndControllabilityDisabled ? 'disabled-radio' : ''">
        <p-radioButton
          required
          name="feed_in_management"
          [value]="feedInManagementValues.limit60PercPowerAndControl"
          [(ngModel)]="technicalData.feed_in_management"></p-radioButton>
        <label
          class="ml-2"
          [pTooltip]="limit60PercPowerAndControllabilityTooltip"
          tooltipStyleClass="netz-info-tooltip"
          tooltipPosition="top">
          {{ 'grid-comp.limit-60-perc-power-and-controllability' | translate }}
        </label>
      </div>
      <div class="section-field" [ngClass]="isSectionDisabled || isControlViaRadioDisabled ? 'disabled-radio' : ''">
        <p-radioButton
          required
          name="feed_in_management"
          [value]="feedInManagementValues.controlViaRadio"
          [(ngModel)]="technicalData.feed_in_management"></p-radioButton>
        <label class="ml-2" [pTooltip]="controlViaRadioTooltip" tooltipStyleClass="netz-info-tooltip" tooltipPosition="top">
          {{ 'grid-comp.control-via-radio' | translate }}
        </label>
      </div>
      <div class="section-field" [ngClass]="isSectionDisabled || isControlViaControlUnitDisabled ? 'disabled-radio' : ''">
        <p-radioButton
          required
          name="feed_in_management"
          [value]="feedInManagementValues.controlViaControlUnit"
          [(ngModel)]="technicalData.feed_in_management"></p-radioButton>
        <label class="ml-2" [pTooltip]="controlViaControlUnitTooltip" tooltipStyleClass="netz-info-tooltip" tooltipPosition="top">
          {{ 'grid-comp.control-via-control-unit' | translate }}
        </label>
      </div>
    </div>
  </div>
</div>
